import React, { useEffect, useState } from "react";
import { Space, Card } from "antd";

import { Button, Form, Input, Select } from "antd";
import ProductOptionService from "services/product_option";
import { useParams, useNavigate } from "react-router";
import { useForm } from "antd/es/form/Form";

const service = new ProductOptionService();

const AddNewParentOption = () => {
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const [listProductOption, setListOption] = useState([]);

  const [isDisableId, setisDisableId] = useState(false);

  const onFinish = async (values) => {
    if (id) {
      var created = await service.update(values);
    } else {
      var created = await service.create(values);
    }
    navigate(`/product_option/`);
    console.log("Success:", created);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    if (id) {
      setisDisableId(true);
      loadData();
    }
  }, [id]);

  const loadData = async () => {
    var item = await service.get(id);
    form.setFieldsValue(item);
  };
  return (
    <Form
      form={form}
      name="basic"
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 16,
      }}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <div>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Card
            size="small"
            title="Cấu hình thuộc tính cha"
            style={{ width: "100%" }}
          >
            <Form.Item label="Mã" name="id" hidden></Form.Item>
            <Form.Item
              label="Tên"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tên thuộc tính cha",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>

            <Form.Item label={null}>
              <Space>
                <Button type="primary" htmlType="submit">
                  {id ? "Cập nhật" : "Tạo thuộc tính cha"}
                </Button>
                <Button
                  onClick={() => {
                    navigate(`/product_option`);
                  }}
                >
                  Thoát
                </Button>
              </Space>
            </Form.Item>
          </Card>
        </Space>
      </div>
    </Form>
  );
};
export default AddNewParentOption;
